import { createResource, type RouteResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL = 'RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const systemConfigurationGeneralResource: RouteResource<any> = createResource({
	type: RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL,
	getKey: () => 'state',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-system-configuration-general", jiraSpaEntry: "async-resource-system-configuration-general" */ './getData.tsx'
		),
});
